import React from "react";
import { Link } from "react-router-dom";
import { LayoutDashboard, HardHat, KeyRound, ArrowLeft, ArrowRight } from "lucide-react";
import { Logo } from "../components/site/Logo";

const PORTALS = [
  {
    to: "/admin/login",
    icon: LayoutDashboard,
    title: "Admin",
    desc: "Project requests, contractors, agents, repair requests, and reports.",
    testid: "login-hub-admin",
  },
  {
    to: "/portal/login",
    icon: HardHat,
    title: "Contractor",
    desc: "Assigned projects, quotes, contracts, and repair-quote requests.",
    testid: "login-hub-contractor",
  },
  {
    to: "/agent/login",
    icon: KeyRound,
    title: "Real Estate Agent",
    desc: "Submit repair-quote requests and review quotes and walk-throughs.",
    testid: "login-hub-agent",
  },
];

export default function LoginHub() {
  return (
    <div className="min-h-screen bg-[#EAF7FC] flex flex-col" data-testid="login-hub">
      <header className="bg-white border-b border-[rgba(19,57,85,0.08)]">
        <div className="max-w-6xl mx-auto px-5 py-4 flex items-center justify-between">
          <Logo />
          <Link to="/" data-testid="login-hub-back" className="inline-flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-bold text-[#133955] hover:bg-[#EAF7FC] transition-colors">
            <ArrowLeft size={16} /> Back to Site
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 py-12">
        <div className="w-full max-w-3xl">
          <div className="text-center mb-8">
            <h1 className="font-display text-4xl md:text-5xl font-extrabold text-[#133955] tracking-tight">Portal Sign In</h1>
            <p className="text-[#173042]/70 mt-2">Choose your portal to continue.</p>
          </div>

          <div className="grid sm:grid-cols-3 gap-4">
            {PORTALS.map((p) => (
              <Link
                key={p.to}
                to={p.to}
                data-testid={p.testid}
                className="group rounded-2xl bg-white border border-[rgba(19,57,85,0.08)] p-6 text-left hover:border-[#54BCE6] hover:shadow-[0_16px_40px_rgba(19,57,85,0.10)] transition-all"
              >
                <span className="grid place-items-center w-12 h-12 rounded-2xl bg-[#133955] text-white mb-4 group-hover:bg-[#54BCE6] group-hover:text-[#133955] transition-colors">
                  <p.icon size={22} />
                </span>
                <h2 className="font-display text-lg font-extrabold text-[#133955]">{p.title}</h2>
                <p className="text-sm text-[#173042]/65 mt-1.5 mb-4">{p.desc}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-bold text-[#54BCE6] group-hover:text-[#133955] transition-colors">
                  Sign In <ArrowRight size={15} />
                </span>
              </Link>
            ))}
          </div>

          <p className="text-center text-sm text-[#173042]/55 mt-8">
            Homeowner? You don't need an account —{" "}
            <Link to="/#request" className="font-bold text-[#133955] hover:text-[#54BCE6]">tell us about your project</Link>.
          </p>
        </div>
      </main>
    </div>
  );
}
